let current = "en";

export const setCurrentLang = (lang) => {
  current = lang;
  document.documentElement.lang = lang;
};

export const getLang = () => current;

export const L = (en, pt, vars) => {
  const text = current === "pt" && pt != null ? pt : en;
  return vars ? text.replace(/\{(\w+)\}/g, (_, k) => String(vars[k] ?? "")) : text;
};
